export default [
  {
    header: 'Модерация',
    resource: 'Auth',
    action: 'read',
  },
  {
    title: 'Мои правки',
    route: 'moderation-my',
    icon: 'EditIcon',
    resource: 'Auth',
    action: 'read',
  },
  {
    title: 'Модерация',
    route: 'moderation-queue',
    icon: 'CheckSquareIcon',
    resource: 'moderation',
    action: 'manage',
  },
  {
    title: 'Выплаты редакторам',
    route: 'moderation-payouts',
    icon: 'DollarSignIcon',
    resource: 'moderation',
    action: 'manage',
  },
]
